export const CLEANING_AREA_SIZES_OPTIONS = [
  { value: '0-1000', label: '0-1,000' },
  { value: '1000-2000', label: '1,000-2,000' },
  { value: '2000-3000', label: '2,000-3,000' },
  { value: '3000-4000', label: '3,000-4,000' },
  { value: '4000-5000', label: '4,000-5,000' },
  { value: '5000+', label: '5,000+' },
];

export const HOME_CONDITION_OPTIONS = [
  { value: 1, label: 'Very Clean' },
  { value: 2, label: 'Light Cleaning Needed' },
  { value: 3, label: 'Average' },
  { value: 4, label: 'Needs Extra Attention' },
  { value: 5, label: 'Heavy Cleaning Needed' },
];

export const CLEANING_TYPE_OPTIONS = [
  { value: 'Standard Clean', label: 'Standard Clean' },
  { value: 'Deep Clean', label: 'Deep Clean' },
  { value: 'Move In/Out Clean', label: 'Move In/Out Clean' },
  { value: 'Post-Construction Clean', label: 'Post-Construction Clean' },
  { value: 'Airbnb Cleaning', label: 'Airbnb Cleaning' },
  { value: 'Organization Cleaning', label: 'Organization Cleaning' },
];

export const FREQUENCY_OPTIONS = [
  { value: 'one-time', label: 'One Time' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'bi-weekly', label: 'Bi-Weekly' },
  { value: 'monthly', label: 'Monthly' },
];

export const US_STATES = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' },
];

/**
 * Configure allowed states for selection.
 * Prefer backend `/cleaners/signup-markets` at runtime; empty array allows no states.
 */
export const ALLOWED_STATES: readonly string[] = [];

/**
 * Filtered states based on ALLOWED_STATES configuration.
 * Use filterUsStatesByCodes() with API values in signup flows.
 */
export const FILTERED_US_STATES =
  ALLOWED_STATES.length === 0
    ? US_STATES
    : US_STATES.filter(state => ALLOWED_STATES.includes(state.value));
